<div class="flex flex-col">
  <div>
    <b>This Feature is not currently enabled for your account</b>
    <br />
    <p>Please contact your administrator to enable this feature</p>
    <p>To learn more about other features, go to <a href="https://ebopro.com/" target="_blank">ebopro.com</a></p>
    <br />
    <p>
      If you think this is in error, please <p-button text="true" (click)="refresh()">click here</p-button> to reload
      your app.
    </p>
  </div>
  <div class="flex grow flex-wrap flex-row justify-center pt-3 w-full">
    <p-button (click)="close()">Ok</p-button>
  </div>
</div>
